declare global {
    interface Window {
        __env?: Record<string, string | undefined>;
    }
}

/**
 * Returns a runtime environment variable, preferring the server-injected
 * window.__env (populated by Blade at request time) over import.meta.env.
 * Using a dynamic key for import.meta.env is intentional — Vite only
 * statically replaces `import.meta.env.VITE_FOO` (literal access), so
 * dynamic access avoids baking values into the bundle at build time.
 */
export function getEnv(key: string, fallback = ''): string {
    const value = window.__env?.[key] ?? (import.meta.env as Record<string, string | undefined>)[key] ?? fallback;
    return String(value);
}
